export function getCountBucket(count: number): number {
    return Math.min(Math.floor(count / 2), 24);
}
